module.exports = __webpack_public_path__ + "static/img/tjbgheng.6baa2bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/tjbgheng.jpg
// module id = Dg5M
// module chunks = 9